<template>
  <UiSidebar
    :is-open="isSidebarOpen"
    :width="OPEN_SIDEBAR_WIDTH"
    :menu="items"
    :additional-menu="additionalItems"
    :additional-bottom-links="additionalBottomLinks"
    @backdrop-visible-change="isBackdropVisible = $event"
    @is-open="updateSidebarState"
  >
    <template #prepend-drawer-content>
      <UiButton
        :class="{
          'ui-sidebar-header-button--active': showSidebarSwitchButton,
        }"
        size="x-small"
        color="button-tertiary"
        :icon="isSidebarOpen ? 'mdi-chevron-left' : 'mdi-chevron-right'"
        density="comfortable"
        class="ui-sidebar-header-button"
        @click.stop="updateSidebarState(!isSidebarOpen)"
      />
    </template>
    <template #logo>
      <AppLogo style="margin-top: -3px" />
    </template>
  </UiSidebar>
</template>

<script setup lang="ts">
import { UiSidebar, UiButton } from '~/ui';
import { AppLogo } from '~/app/layouts/logo';
import useSidebarItems from '../composables/useSidebarItems';
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useSidebarStore } from '~/app/layouts/sidebar/stores';
import { useProductFilterStore } from '~/domains/product';
import { OPEN_SIDEBAR_WIDTH } from '~/app/layouts/sidebar';

const { items, additionalItems, additionalBottomLinks } = useSidebarItems();

const isBackdropVisible = ref(false);
const { isOpenFilter } = storeToRefs(useProductFilterStore());
const { isSidebarOpen } = storeToRefs(useSidebarStore());
const { updateSidebarState } = useSidebarStore();

const showSidebarSwitchButton = computed(
  () => !isBackdropVisible.value && !isOpenFilter.value,
);

watch(
  () => isOpenFilter.value,
  (value) => {
    updateSidebarState(!value);
  },
);
</script>

<style lang="scss" scoped>
.ui-sidebar-header-button {
  position: absolute;
  right: -7px;
  top: 20px;
  color: white !important;
  z-index: 2;
  opacity: 0;
  transition: opacity 0s ease-in-out;
  pointer-events: none;
  width: 16px;
  max-width: 16px;
  height: 24px;
  border-radius: 12px;

  &--active {
    opacity: 1;
    pointer-events: auto;
    transition: opacity 0.2s 0.3s ease-in-out;
  }
}
</style>
